<template>
  <div class="loading-wrap">
    <div>
      <img src="../assets/images/img-error02.png" alt="에러 페이지 아이콘" class="img-error02" />
    </div>
    <p class="loading-tit">서비스 점검 중입니다.</p>
    <p class="loading-text">잠시만 기다려 주세요.<br/>예상시간 : {{count}} 초</p>
    <div class="loading-spinner-wrap">
      <span class="loading-spinner rotate"></span>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import { getServiceLocation } from '@/common/api/api.service'
import { setServiceLocationInfo } from '@/common/util/common'
import utils from '@/common/util/utils'
import { SERVICE_LOCATION_KEY } from '@/common/constant'

export default {
  name: 'waitingService',
  data () {
    return {
      defaultCount: 60,
      count: 60,
      countTimer: null
    }
  },
  methods: {
    startCount () {
      this.count = this.defaultCount
      this.countTimer = setInterval(() => {
        this.count -= 1
        if (this.count < 1) {
          this.checkServiceLocation()
          clearInterval(this.countTimer)
        }
      }, 1000)
    },
    checkServiceLocation () {
      getServiceLocation(utils.cookies.getCredential()).then(({ data }) => {
        const isService = get(data, 'isservice', 'y') === 'y'
        if (isService) {
          setServiceLocationInfo(data)
          this.$router.replace('/')
        } else {
          this.startCount()
        }
      })
    }
  },
  created () {
    if (utils.cookies.getCredential() === 'none') {
      sessionStorage.removeItem(SERVICE_LOCATION_KEY)
      this.$router.replace('/')
    } else {
      this.checkServiceLocation()
    }
  }
}
</script>

<style scoped>
  .loading-wrap{
    padding: 70px 20px;
    text-align: center;
  }

  .loading-wrap .img-error02{
    display: block;
    width: 92px;
    margin: 0 auto 40px;
  }

  .loading-tit{
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    letter-spacing: -0.33px;
  }

  .loading-text{
    margin-top: 20px;
    font-size: 14px;
    line-height: 24px;
    color: #a5a5a5;
    letter-spacing: -0.27px;
  }

  .loading-progress {
    width: 80px;
    height: 80px;
  }
  .spinner {
    width: 80px;
    height: 80px;
    animation-iteration-count: infinite;
  }
  .loading{
    width: 80px;
    height: 80px;
    /*background: url(../assets/images/common/loading.png) no-repeat 0 0;*/
    background-size: cover;
    animation:box 1s steps(12) infinite;
  }
  @keyframes box {
    from {background-position:0 0}
    to   {background-position:-960px 0}
  }
</style>
